import React, { useEffect, useState } from 'react';
import {
  Typography,
  TextField,
  IconButton,
  Tooltip,
  Box,
  Switch,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import { CustomDataGrid } from '../../../common/components/Table/CustomDataGrid';
import CustomExportButton from '../../../common/components/Table/CustomExportButton';
import httpCommon from '../../../http-common';
import { useGridApiRef } from '@mui/x-data-grid';
import ContainedButton from '../../../common/components/Buttons/ContainedButton';
import { FileUploaderRipik } from '../../HomePage/components/FileUploaderRipik';
import SnackbarWithMessage from '../../../common/components/Snackbars/SnackbarWithMessage';
import { mixpanelTrackTabsButton } from '../../../mixPanelFunctions/mixPanelFunctions';

const postMachine = async (machine_id) => {
  const data = JSON.stringify({ machine_id: machine_id });
  try {
    const response = await httpCommon.post(`/v1/qc/test_to_machine`, data);
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`Analyst couldn't be added, response message:${result.message}`);
  } catch (error) {
    console.log({ error });
    return false;
  }
};

const deleteMachine = async (machine_id) => {
  const data = JSON.stringify({ machine_id });
  try {
    const response = await httpCommon.delete(`/v1/qc/test_to_machine`, { data });
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`Machine couldn't be deleted, response message:${result.message}`);
  } catch (error) {
    console.log({ error });
    return false;
  }
};


const MachineMappingDashboard = () => {
  const apiRef = useGridApiRef();
  const [columns, set_columns] = useState([]);

  // fetch_tests
  // const fetch_tests = async () => {
  //   try {
  //     const response = await httpCommon.get(`v1/qc/get_tests`);
  //     const result = response?.data?.tests;
  //     return result;
  //   } catch (error) {
  //     console.log({ error });
  //   }
  // };

  const handleUpdateRow = (rowId, other_data) => {
    // const rowIds = apiRef.current.getAllRowIds();

    apiRef.current.updateRows([{ id: rowId, ...other_data }]);
  };


  // generate columns function
  const generateColumns = async (fetched_names = []) => {
    // const fetched_names = await fetch_tests();
    const headers = [{
      field: 'Machine ID',
      headerName: 'Machine ID',
      width: 150,
      renderCell: (params) => (
        <div style={{ position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
          {params.value}
        </div>
      ),
    },
    ...fetched_names.map((test) => ({
      field: test,
      headerName: test,
      width: 150,
      renderCell: (params) => (
        <div
          onClick={async () => {
            console.log({ params });
            const { "Machine ID": machine_id } = params.row;
            const update_fields = {
              [params.field]: params.row[params.field] === "Y" ? "N" : "Y"
            };
            const data_to_update = JSON.stringify({
              machine_id,
              update_fields
            });
            const response = await httpCommon.patch(`/v1/qc/test_to_machine`, data_to_update);
            const result = response.data.status;
            if (result === "success") {
              const rowId = params.id;
              const other_data = { ...response.data.data };
              handleUpdateRow(rowId, other_data);
            }
            else return false;
            // handleMappingChange(params.row.machine_id, params.field);
          }}
          style={{
            cursor: 'pointer',
            textAlign: 'center',
          }}
        >
          <Tooltip title={params.row[params.field] === 'Y' ? 'Yes' : 'No'}>
            {getStatusIcon(params.row[params.field])}
          </Tooltip>
        </div>
      ),
    })),
    ];
    headers.push(
      {
        field: 'is_disabled',
        headerName: 'Enable',
        width: 100,
        renderCell: (params) => (
          <div style={{ position: 'sticky', right: 0, zIndex: 1 }}>
            <Switch checked={!params?.row?.is_disabled} onClick={() => {
              handleDeleteMachine(params);
            }} />
            {/* <IconButton onClick={() => handleDeleteMachine(params)}>
              <DeleteIcon style={{ color: '#ff5722' }} />
            </IconButton> */}
          </div>
        ),
      },
    );
    set_columns(headers);
  };

  // call generate column in useEffect
  useEffect(() => {
    generateColumns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const [machineTestMapping, setMachineTestMapping] = useState([]);
  const [newMachineName, setNewMachineName] = useState('');


  const [data, setData] = useState([]);

  const handleAddMachine = async () => {
    console.log({ data });
    const machine_id = newMachineName;
    const result = await postMachine(machine_id);
    if (result === true) {
      setData((prevData) => [{ id: machine_id, "Machine ID": machine_id }, ...prevData]);
      setNewMachineName('');
      mixpanelTrackTabsButton("MachineMappingDashboard","add machine","master-sheet") // tracking tab button
      console.log("machine added:", machine_id);
    }
    else {
      console.log("machine couldn't be added.");
    }
  };
  const fetchData = async () => {
    try {
      const response = await httpCommon.get(`/v1/qc/test_to_machine`);
      const dummyData = response.data.data.filter(item => item?.[`Machine ID`] !== null).map(item => ({
        ...item,
        id: item._id,
      }));
      console.log(dummyData);
      setData(dummyData);
      const { _id, "Machine ID": m_id, id, ...cols } = dummyData[0];
      generateColumns(Object?.keys(cols || {}));

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    // Simulate fetching data from APIs (using a Promise)

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handleMappingChange = (machine, test) => {
  //   // Toggle the test value ("Y" to "N" and vice versa) for the specified machine and test
  //   const updatedMapping = { ...machineTestMapping };
  //   updatedMapping[machine][test] = updatedMapping[machine][test] === 'Y' ? 'N' : 'Y';
  //   setMachineTestMapping(updatedMapping);
  // };

  const handleDeleteMachine = async (params) => {
    // Delete a machine and its mapping
    const response = await deleteMachine(params.row?.["Machine ID"]);
    if (response === true) {
      const row_id = params.row.id;
      apiRef.current.updateRows([{
        id: row_id,
        // _action: "delete"
        is_disabled: !params?.row?.is_disabled
      }]);
    }
    else {
      console.log("probably this machine is already deleted, reloading the data for you.");
      fetchData();
    }
  };

  const getStatusIcon = (status) => {
    return status === 'Y' ? (
      <CheckCircleIcon style={{ color: '#4caf50' }} />
    ) : (
      <CancelIcon style={{ color: '#ff5722' }} />
    );
  };

  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const [file, set_file] = useState(null);

  const handle_file_upload = async (uploaded_file) => {
    try {
      const data = new FormData();
      data.append("excel_file", uploaded_file);
      // console.log([...data.entries()]);
      const response = await httpCommon.post(`/v1/qc/upload_mastersheet/test_to_machine/`, data, {
        "headers": {
          "Content-Type": "multipart/form-data"
        }
      });
      const result = response.data;
      mixpanelTrackTabsButton("MachineMappingDashboard","file upload","master-sheet") // tracking tab button
      console.log({ result });
      if (result.status === "error") {
        set_open_snackbar_with_message({
          message: result.message,
          open: true,
          severity: "error"
        });
      }
      else if (result.status === "success") {
        set_open_snackbar_with_message({
          message: `Data uploaded successfully!`,
          open: true,
          severity: "success"
        });
        fetchData();
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <Box>
      {/* <Typography variant="h4" gutterBottom>
        Machine Test Mapping Dashboard
      </Typography> */}
      <Box>
        <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
          set_open_snackbar_with_message({
            open: false,
            message: "",
            severity: "info"
          });
        }} />
        <Box className="flex justify-end items-center">
          <FileUploaderRipik file={file} file_update_function={(uploaded_file) => {
            set_file(uploaded_file);
            console.log(uploaded_file);
            handle_file_upload(uploaded_file);
          }} upload_message={`Upload File Here`} />
        </Box>
        <CustomDataGrid
          apiRef={apiRef}
          rows={data}
          columns={columns}
          // disableSelectionOnClick
          disableRowSelectionOnClick
          rowHeight={50}
          headerHeight={60}
          initialState={{
            pinnedColumns: {
              left: ["machine_id"],
              right: ["is_disabled"],
            }
          }}
          sx={{
            height: "500px"
          }}
          hideFooter
          slots={{
            toolbar: CustomExportButton
          }}
        />
      </Box>
      <Box mt={2} className="">
        <Typography variant="h6">Add New Machine</Typography>
        <Box className="flex items-center gap-2">
          <TextField
            name="machine_id"
            label="Machine ID"
            value={newMachineName}
            onChange={(e) => setNewMachineName(e.target.value)}
            variant="outlined"
            margin="dense"
          />
          {/* Add other TextField components for additional columns */}

          <ContainedButton variant="contained" color="primary" onClick={handleAddMachine}>
            Add Machine
          </ContainedButton>
        </Box>
      </Box>
    </Box>
  );
};

export default MachineMappingDashboard;
